import React, { useState } from 'react';

// Styles & Assets
import styles from './ButtonsTablePreconfig.module.css';
import { AiOutlineSearch } from 'react-icons/ai';
import { MdEdit } from 'react-icons/md';

// Components
import Modal from '../../UI/Modal/Modal';
import ViewPreconfigDialog from '../ViewPreconfigDialog/ViewPreconfigDialog';
import DuplicatePreconfigButton from '../DuplicatePreconfigButton/DuplicatePreconfigButton';
import PreconfigActionButton from '../PreconfigActionButton/PreconfigActionButton';
import DeletePreconfigButton from '../DeletePreconfigButton/DeletePreconfigButton';

// Interfaces
import { Preconfiguration } from '../../../interfaces/Preconfigurations';

interface Props {
    preconfiguration: Preconfiguration
    addPreconfig: (id: Preconfiguration) => void
    deletePreconfig: (id: Preconfiguration['id']) => void
    caseIdsLinked?: number[]
}

const ButtonsTablePreconfig: React.FC<Props> = ({
    preconfiguration,
    addPreconfig,
    deletePreconfig,
    caseIdsLinked = []
}) => {
    const [showViewPreconfig, setShowViewPreconfig] = useState(false);

    const handleClickView = (evt: React.FormEvent) => {
        evt.stopPropagation();
        setShowViewPreconfig(true);
    };

    return (
        <div className={styles.buttonsActions}>
            <PreconfigActionButton type='button' onClick={handleClickView}>
                <AiOutlineSearch />
            </PreconfigActionButton>

            <PreconfigActionButton type='link' to='create-preconfig/' state={{ preconfiguration }}>
                <MdEdit />
            </PreconfigActionButton>

            <DuplicatePreconfigButton
                preconfiguration={preconfiguration}
                addPreconfig={addPreconfig}
            />

            <DeletePreconfigButton
                preconfiguration={preconfiguration}
                deletePreconfig={deletePreconfig}
                caseIdsLinked={caseIdsLinked}
            />

            <Modal show={showViewPreconfig} setShowModal={setShowViewPreconfig}>
                <ViewPreconfigDialog
                    preconfiguration={preconfiguration}
                    showModal={setShowViewPreconfig}
                />
            </Modal>
        </div>
    );
};

export default ButtonsTablePreconfig;